import { type TeamAgentAssociation } from '@atlaskit/teams-client/types';

import { type TeamAppState } from '../../types';

export const addAgentState = (
	teamState: TeamAppState,
	newAgents: TeamAgentAssociation[],
): TeamAppState => {
	const { teamAgents } = teamState;

	const accountIds = new Set(newAgents.map(({ associationId }) => associationId.accountId));

	const existingAgents = teamAgents.agents.filter((agent) => {
		return !accountIds.has(agent.associationId.accountId);
	});

	const finalAgents = existingAgents.concat(newAgents);

	return {
		...teamState,
		teamAgents: {
			...teamState.teamAgents,
			teamId: teamState.teamAgents.teamId,
			hasLoaded: true,
			hasError: false,
			isLoading: false,
			errorType: null,
			agents: finalAgents,
		},
	};
};
